export default "__VITE_ASSET__ixkfTYnl__"